import { HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { APP_ROUTES } from '@core/constants/routes.constants';
import { UIService } from '@core/services/ui.service';
import { TranslateService } from '@ngx-translate/core';
import { map, Observable, of } from 'rxjs';

export function injectGuardDenials() {
  const router = inject(Router);
  const uiService = inject(UIService);
  const translateService = inject(TranslateService);

  const toast$ = (key: string) =>
    translateService
      .get(key)
      .pipe(
        map((summary: string) =>
          uiService.showToast({ severity: 'error', summary, life: 3000, closable: false })
        )
      );

  return {
    noPermission$: (): Observable<false> =>
      toast$('errors.noPermission').pipe(
        map(() => {
          void router.navigate([APP_ROUTES.HOME]);
          return false as const;
        })
      ),
    accountLoadFailed$: (error: unknown): Observable<false> =>
      error instanceof HttpErrorResponse && error.status === 401
        ? of(false as const)
        : toast$('errors.accountLoadFailed').pipe(map(() => false as const)),
  };
}
